import React from "react";
import "./styles.css";
import api from   './../../../services/api';
//import { NavLink } from 'react-router-dom';
import { user_token } from '../../../services/Auth';
import "./styles.css";
import Grid from '@material-ui/core/Grid';
import SideNav from './../../../components/SideNav_RI';
import GetUser from './GetUser';
import { Collapse } from "react-collapse";

import {agent} from '../../../services/api';
let apiAgent = new agent();

var token = localStorage.getItem(user_token);

export default class RI_ConsultasDetalhes extends React.Component {

    state = {
        exames: [],
    }

    componentDidMount(){
        this.loadData();
    }

    loadData = async () => {
        const { id } = this.props.match.params;
        console.log(id);
        //const request = await api.get(`/exam/${id}`, {headers: {'x-access-token': token}});
        const request = await apiAgent.getExam(id);
        console.log(request);
        console.log(request.data);
        this.setState({ exames: request.data });
    
      };

    render() {
        return (
        <>
        <SideNav />
        <div id="top-RI-Cadastro">
        <Grid container spacing={0} direction="row" justify="left"  alignItems="center" style={{ marginTop: '-35vh'}}>
          <Grid item xs={2} sm={2} md={1} lg={1} align="center">     
               
            </Grid>
            <Grid item xs={8} sm={8} md={10} lg={10}></Grid>   
            <Grid item xs={2} sm={2} md={1} lg={1} align="center"> 
          </Grid>
        </Grid>
        </div>
          <Grid container spacing={0} direction="row" justify="left"  alignItems="center">
          <Grid item xs={12} sm={12} md={10} lg={3} align="center"></Grid>
          <Grid item xs={12} sm={12} md={10} lg={6} align="center">
          <div id="main-RI-Consulta-Pendente">
          <br></br>
          <div id="lista-style">
          {this.state.exames.map(details => (
          <> 
            <div id="exam">

              <h1 id="tittle-forms-cme">Dados da Consulta</h1>
              <hr id="coloring_line"/>
              <p id="RI-Title-Cadastro-Paciente">Período disponível para consulta: </p><p>{details.appointment_period}</p>
              <p id="RI-Title-Cadastro-Paciente">Tipo de Consulta Desejada:</p><p>{details.appointment_type}</p>
              {
              details.appointment_type === "Medicina" ? <> <p id="RI-Title-Cadastro-Paciente">Especialidade Médica:</p>{details.medical_appointment_type}</> :
              null
              }
              <p id="RI-Title-Cadastro-Paciente">Motivo da Consulta: </p><p>{details.appointment_purpose}</p>
              <p id="RI-Title-Cadastro-Paciente">Obervações:</p><p>{details.notes}</p>
              <p id="RI-Title-Cadastro-Paciente">Status:</p><p>{details.status}</p>
              <p id="RI-Title-Cadastro-Paciente">Notas do(a) Profissional da Saúde:</p><p>{details.medical_note}</p>
              <p id="RI-Title-Cadastro-Paciente">Receita:</p><p>{details.prescription}</p>       
              <hr id="coloring_line"/>
              <br></br>
              <h1 id="tittle-forms-cme">Informações do Paciente</h1>
              <hr id="coloring_line"/>
              <GetUser user_id = {details.user_id} meeting_link = {details.meeting_link}/>

              <Collapse isOpened={details.status === 'Confirmada'}>
                <hr id="coloring_line"/>
                <br></br>
                <div>
                    <a id="RI-Title-Cadastro-Paciente" href={details.meeting_link} target="_blank">
                        <button id="RI-Cadastro">Iniciar chamada por vídeo</button>
                    </a>
                </div>
                <div>
                <br/>
                <hr id="coloring_line"/>
                <p id="RI-Title-Cadastro-Paciente" >Caso o botão iniciar video chamada não funcione copie e cole esse link no navegador: <a href = {details.meeting_link} target='_blank' >{details.meeting_link}</a></p>
                <br/>
                <p id="RI-Title-Cadastro-Paciente" >Caso tenha alguma dúvida acesse o manual do Representante de instituição<a href = 'https://drive.google.com/file/d/1Z6pAptVia5ac1Yoth9LF81gxMvwM5oGh/view' target='_blank'> clicando aqui </a></p>
                </div>
              </Collapse>
              <br></br>

            </div>
          </>
          ))}
        </div>
        </div>
        </Grid>
        </Grid>
      </>
        );
    }
}

/*
export default function RI_ConsultasDetalhes() {
    let [search, setSearch] = useState(false);
    let [options, setOptions] = useState(false);
    let [pacienteDet, setPacientDet] = useState(false);
    let [consultaDet, setConsultaDet] = useState(false);
    return (
        <>
            <SideNav />
            <div id="top-RI-Cadastro">
                <NavLink id="RI-cadastro" to="/RI_Consultas"><button id="exit-RI-Cadastro">Voltar</button></NavLink>
                <div style={{display:"flex", flexDirection:"row"}}>
                    <Collapse isOpened={search}>
                        <input id="RI-Cadastro-Search" placeholder="pesquisar..." />
                    </Collapse>
                    <AiOutlineSearch
                        size={"6vh"}
                        onClick={() =>
                            setSearch(!search)
                        }
                        id="Icon-Search-RI-Cadastro"
                    />
                </div>
            </div>
            <div id="main-RI-Consultas-Detalhes">
                <div id="actions-RI-Consultas-Detalhes">
                    <p id="RI-Consultas-Detalhes">Ações</p>
                    <hr id="divider-RI-Consultas-Detalhes" />
                    <div id="arrow-Consultas-Detalhes">
                        <IoIosArrowDown
                            onClick={() =>
                                setOptions(!options)
                            }
                            size={"6vh"}
                            id="IconDown-RI-Consultas-Detalhes"
                        />
                    </div>
                    <Collapse isOpened={options}>
                        <div id="collapsed-Consultas-Detalhes-Acoes">
                        <button id="exit-RI-Consultas-Detalhes">EXCLUIR</button>
                        </div>
                    </Collapse>
                </div>
                <DataExam />
            </div>
        </>
    );
}
*/